import { render } from "./SurveyCountRecord.vue?vue&type=template&id=59e56902&scoped=true"
import script from "./SurveyCountRecord.vue?vue&type=script&lang=ts"
export * from "./SurveyCountRecord.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-59e56902"

export default script